<template>
  <TemplateDbsUnlocking v-if="isReadyToDraw" />
  <DialogInitialLoading v-else />

  <!-- 予約有効期限切れ時のダイアログ -->
  <DialogReservationExpired ref="DialogReservationExpired" />
</template>

<script>
import { onMounted, ref } from "vue";
import { useStore } from "vuex";

import API from "@/API";
import dbsService from "@/services/dbs";
import TemplateDbsUnlocking from "@/views/Templates/Dbs/TemplateDbsUnlocking";

export default {
  name: "DbsUnlocking",
  components: {
    TemplateDbsUnlocking: TemplateDbsUnlocking,
  },
  setup() {
    const store = useStore();
    
    const isReadyToDraw = ref(false);
    const DialogReservationExpired = ref(null);

    onMounted(async () => {
      try {
        // 予約チェックと同時に、予約情報を取得してstoreにセット
        if (await dbsService.isExpiredReservation()) {
          DialogReservationExpired.value.openDialog();
        } else {
          // reservationのレスポンスのidを使って、park情報を取得する
          const reservationInfo = store.getters["dbs/reservation"];
          await API.getDbsPark(reservationInfo.park_info.park_id);
          isReadyToDraw.value = true;
        }
      } catch (e) {
        console.log("Error in DbsUnlocking.onMounted()", e);
      }
    });

    return {
      isReadyToDraw,
      DialogReservationExpired,
    };
  },
};
</script>
